import React, { useEffect, useState } from 'react';
import BottomNav from './BottomNav';
import FloatingTodayButton from './FloatingTodayButton';
import TopHeader from './TopHeader';

const MainLayout = ({ 
  children, 
  currentDay,
  title,
  showBack,
  darkMode,
  onToggleDarkMode,
  onOpenSync,
  hideNav = false
}) => {
  const [isDesktop, setIsDesktop] = useState(false);

  useEffect(() => {
    const checkDesktop = () => setIsDesktop(window.innerWidth >= 1024);
    checkDesktop();
    window.addEventListener('resize', checkDesktop);
    return () => window.removeEventListener('resize', checkDesktop);
  }, []);

  // Apply dark mode to document root for proper cascading
  useEffect(() => {
    if (darkMode) {
      document.documentElement.classList.add('dark');
      document.body.classList.add('dark');
    } else {
      document.documentElement.classList.remove('dark');
      document.body.classList.remove('dark');
    }
  }, [darkMode]);

  return (
    <div className="min-h-screen bg-[var(--background)] transition-colors duration-300">
      {/* Desktop Sidebar is rendered by BottomNav component when isDesktop */}
      
      {/* Top Header - hidden on desktop as sidebar has title */}
      {!isDesktop && (
        <TopHeader 
          title={title}
          showBack={showBack}
          darkMode={darkMode}
          onToggleDarkMode={onToggleDarkMode}
          onOpenSync={onOpenSync}
        />
      )}
      
      {/* Main content area - extra padding for mobile nav */}
      <main className={`main-app-content pb-24 ${isDesktop ? 'lg:ml-60 lg:pb-8' : 'pb-28'}`}>
        <div className={isDesktop ? 'max-w-4xl mx-auto px-8 py-6' : ''}>
          {children}
        </div>
      </main>

      {/* Floating Today button - REMOVED: Duplicate day indicator 
          The day is already shown in the main content area */}
      
      {/* Navigation */}
      {!hideNav && <BottomNav />}
    </div>
  );
};

export default MainLayout;
